<template>
  <div>
    <!-- eslint-disable-next-line -->
    <fieldset v-for="(item, index) in contextPassengers" class="custom-fieldset">
      <div
        style="position: absolute;
    right: 0;
    margin-top: -30px;"
      >
        <v-btn @click="removePerson(user)" icon style="background-color: lightgrey">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <order-user-select :value.sync="contextPassengers[index]" :birth-date-required="birthDateRequired" />
    </fieldset>
    <v-btn @click="addPeople" class="primary">{{ $t("travelService.multipleUserSelect.addPerson") }}</v-btn>
  </div>
</template>

<script>
import OrderUserSelect from "./OrderUserSelect";

export default {
  name: "MultipleUserSelect",
  components: { OrderUserSelect },
  props: {
    birthDateRequired: {
      default: false,
      required: false
    }
  },
  data: () => ({
    contextPassengers: []
  }),
  watch: {
    contextPassengers: {
      deep: true,
      handler() {
        if (JSON.stringify(this.contextPassengers) !== JSON.stringify(this.editedTravelServiceOrderItem.travelServiceOrderItemPassengers)) {
          this.updateVuexState();
        }
      }
    },
    "editedTravelServiceOrderItem.travelServiceOrderItemPassengers": {
      deep: true,
      handler(val) {
        this.contextPassengers = JSON.parse(JSON.stringify(val));
      }
    }
  },
  computed: {
    editedTravelServiceOrderItem() {
      return this.$store.state.TravelService.editedTravelServiceItem;
    }
  },
  methods: {
    addPeople() {
      this.$store.dispatch("TravelService/addPassenger");
    },
    removePerson(item) {
      if (this.contextPassengers.length > 1) {
        this.contextPassengers.splice(this.contextPassengers.indexOf(item), 1);
        this.updateVuexState();
      } else {
        this.$store.dispatch("snackbarPush", {
          text: this.$t("travelService.multipleUserSelect.canNotRemoveLastPerson"),
          color: "error",
          position: "down"
        });
      }
    },
    updateVuexState() {
      let tempEditedTravelServiceOrderItem = this.editedTravelServiceOrderItem;
      tempEditedTravelServiceOrderItem.travelServiceOrderItemPassengers = this.contextPassengers;
      this.$store.commit("TravelService/setEditedTravelServiceItem", tempEditedTravelServiceOrderItem);
    }
  },
  created() {
    this.contextPassengers = JSON.parse(JSON.stringify(this.editedTravelServiceOrderItem.travelServiceOrderItemPassengers));
  }
};
</script>

<style scoped></style>
